import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

// NOTE: shadcn's stock animate-in/zoom-in classes are omitted because the
// tailwindcss-animate plugin is not enabled in tailwind.config.js.
const TooltipContent = React.forwardRef(({ className, sideOffset = 6, ...props }, ref) => (
    <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            collisionPadding={12}
            className={cn(
                "z-[1080] max-w-[36rem] rounded-md border border-border bg-popover px-3 py-2 text-left text-sm font-normal leading-snug text-popover-foreground shadow-md",
                className
            )}
            {...props}
        />
    </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
